<script setup>
import { computed } from 'vue'

import DetailField from '@/components/shared/DetailField.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})

const pairs = computed(() => {
  const visible = props.items.filter(item => item.value != null && item.value !== '')
  return Array.from({ length: Math.ceil(visible.length / 2) }, (_, index) => visible.slice(index * 2, index * 2 + 2))
})
</script>

<template>
  <q-list>
    <q-item v-for="(pair, index) in pairs" :key="index" dense>
      <detail-field
        v-for="(item, side) in pair"
        :key="item.label"
        class="col-6"
        :label="item.label"
        :right="side === 1"
      >
        <span :class="{ 'text-primary text-weight-medium': item.highlight }">{{ item.value }}</span>
      </detail-field>
    </q-item>
  </q-list>
</template>
